import {useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {useOperatorPage} from '@/components/no-access-state'
import {PlanLockedPage} from '@/components/plan-upsell'
import {OrganigramaSection} from '@/components/perfil/organigrama-section'
import {useCapabilities} from '@/hooks/empresa/organizacion/use-businesses'

export function OrganigramaPage() {
  const {t} = useTranslation()
  const {businessId} = useParams()
  const {business, canEdit, guard} = useOperatorPage(businessId)
  const capabilities = useCapabilities(businessId)
  if (guard) return guard
  if (!business) return null

  if (!capabilities.can_use_jerarquia) {
    return (
      <PlanLockedPage feature={t('plans.feature.jerarquia')} businessId={business.id} businessName={business.name} />
    )
  }

  return (
    <div className="space-y-6">
      <PageHeading title={t('organigrama.title')} />
      <OrganigramaSection businessId={business.id} canEdit={canEdit} />
    </div>
  )
}
